import { FC } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Autocomplete
} from "@material-ui/core";
import { DropdownOption, GenericAppThemeProperty } from "../Types";
import { useAppThemeContext } from "src/contexts/AppThemeContext";

type OptionsPropertyCardProps = {
  property: GenericAppThemeProperty;
  options: DropdownOption[];
};

const OptionsPropertyCard: FC<OptionsPropertyCardProps> = ({ property, options }) => {
  const { updateGenericData } = useAppThemeContext();

  return (
    <Card
      variant="outlined"
      sx={{
        transition: "all 0.2s ease-in-out",
        "&:hover": { boxShadow: 1, transform: "translateY(-1px)" },
      }}
    >
      <CardContent
        sx={{
          py: 1.5,
          px: 2,
          "&:last-child": { pb: 1.5 },
          "&:first-child": { pt: 1.5 },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Box>
            <Typography variant="subtitle2" fontWeight={600} color="primary">
              {property.propertyLabel}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Autocomplete
              options={options}
              size="small"
              disableClearable
              getOptionLabel={(option: DropdownOption) => option.label}
              getOptionSelected={(option, value) => option.value === value.value}
              value={options?.find((opt) => opt.value === property.value) || null}
              onChange={(_, selectedOption: DropdownOption) => {
                if (selectedOption) {
                  updateGenericData(property.category, property.themePropertyKey, selectedOption.value);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Value" variant="outlined" />
              )}
              style={{ minWidth: 180 }}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default OptionsPropertyCard;
